import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { DomainSupplyChain } from 'features/globalSetup/types/domainSupplyChain'
import { CustomDomainSidInputCell } from '../../components/CustomDomainSidInputCell'

export const useColumns = (): ColumnDef<DomainSupplyChain>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'supplyChain.domainSids.headers',
  })

  return [
    {
      accessorKey: 'domain.name',
      header: t('domainName'),
      meta: { isPinned: true },
    },
    {
      accessorKey: 'customDomainSid',
      cell: context => <CustomDomainSidInputCell {...context} />,
      header: t('customDomainSid.label'),
      meta: { tooltip: { content: t('customDomainSid.tooltip') } },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('lastModified'),
    },
  ]
}
